import { axios } from '@platform/rcl';

export function fetchAccount () {
  return (dispatch) => dispatch({
    type: 'FETCH_ACCOUNT',
    payload: axios().get('/api/account'),
  });
}
